import { Editor, Range } from "slate";

export const hasSelection = (editor: Editor) => {
  return !!editor.selection && !Range.isCollapsed(editor.selection);
};
